// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u5hA","icon":"styles_icon__jhB1V"};